<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<div class="image2" id="pAeZ"><img alt="images/himg-6-1.jpg" src="images/himg-6-1.jpg"/></div>
<h1 class="chapter1"><b>C<span class="smallcaps">ONTENTS</span> </b></h1>
<p class="level1"><a href="#/chapter01#toc_pz6-1" id="con_pz6-1">Introduction</a></p>
<p class="level1"><a href="#/chapter03#pz8-5">Begin Reading</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2a08bb97